import React from "react";
import { Controller } from "react-hook-form";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FormHelperText, OutlinedInput, Typography } from "@mui/material";
import { StyledMenuItem } from "../../forms/StyledComponents";

const SelectWrapper = ({
  label,
  inputLabel,
  data = [],
  helperText,
  autoWidth,
  placeholder,
  control,
  name,
  defaultValue,
  width,
  disabled = false,
  validation,
  isRequired,
}) => {
  console.log("fromSelectInput", width);
  return (
    <Controller
      name={name || "name"}
      control={control}
      rules={validation}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl sx={{ width: width || "18.25vw" }} size="small" disabled={disabled} error={!!error}>
          <Select
            displayEmpty
            value={value || defaultValue || ""}
            onChange={onChange}
            autoWidth={autoWidth}
            sx={{ width: width || "18.25vw", borderRadius: "1px" }}
            size="small"
            variant="outlined"
            required={isRequired}
            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>{placeholder}</em>;
              }

              return selected;
            }}
            // MenuProps={MenuProps}
            inputProps={{ "aria-label": "Without label" }}
          >
            <StyledMenuItem disabled value="">
              <em>{placeholder}</em>
            </StyledMenuItem>
            {Array.isArray(data) &&
              data?.map((item) => {
                const dropdowns = item?.name || item?.value || item?.i18nKey;
                return (
                  <StyledMenuItem
                    value={dropdowns}
                    key={dropdowns}
                    // className={width && "customWidth"}
                  >
                    {dropdowns}
                  </StyledMenuItem>
                );
              })}
          </Select>
          {error && (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          )}
          {helperText && !error && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default SelectWrapper;
